import stripeJs from '@stripe/stripe-js'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { initErrorAction, setStripeErrorAction } from 'reducks/error/actions'
import { getPaymentMethod } from 'lib/stripe'
import { auth } from 'firebase/index'
import axios from 'axios'
import { REGISTER_CARD_ENDPOINT } from 'constants/urls'
import { registerCardAction } from 'reducks/shop/actions'
import { push } from 'connected-react-router'

const registerCard = (elements: stripeJs.StripeElements | null, stripe: stripeJs.Stripe | null) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())
    dispatch(initErrorAction())

    const { payment_method_id, message } = await getPaymentMethod(elements, stripe)

    if (typeof payment_method_id === 'undefined') {
      dispatch(hideLoadingAction())
      dispatch(setStripeErrorAction(message))
      return
    }

    // トークンを取得する
    const token = await auth.currentUser?.getIdToken()

    if (typeof !token === 'undefined') {
      dispatch(hideLoadingAction())
      console.error('認証トークンの取得に失敗しました。')
      return
    }

    const name = getState().shop.name
    const stripeCustomerId = getState().shop.stripe_customer_id
    const prevPaymentMethodId = getState().shop.stripe_payment_method_id
    const shopId = getState().shop.shop_id
    const uid = getState().auth.uid

    try {
      const res = await axios.post(
        REGISTER_CARD_ENDPOINT,
        {
          customer_id: stripeCustomerId,
          name: name,
          payment_method_id: payment_method_id,
          prev_payment_method_id: prevPaymentMethodId,
          shop_id: shopId,
          uid: uid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      dispatch(hideLoadingAction())
      if (!res || !res.data || !res.data.customer_id) {
        dispatch(
          setStripeErrorAction(
            prevPaymentMethodId === ''
              ? 'カード情報の登録中にエラーが発生しました。'
              : 'カード情報の更新に失敗しました。'
          )
        )
        return
      }
      dispatch(registerCardAction(res.data.customer_id, payment_method_id))
      dispatch(push('/contract/card/complete'))
    } catch (e) {
      if (!axios.isAxiosError(e)) {
        console.error(e)
      } else {
        const code = e.response?.data?.code || ''
        dispatch(hideLoadingAction())
        switch (code) {
          case 'expired_card':
            dispatch(setStripeErrorAction('カードの有効期限が切れています。他のカードでお試しください。'))
            break
          case 'incorrect_cvc':
            dispatch(setStripeErrorAction('セキュリティコードが正しくありません。再度ご確認をお願いします。'))
            break
          case 'incorrect_number':
            dispatch(setStripeErrorAction('カード番号が間違っています。再度カード番号のご確認をお願いします。'))
            break
          default:
            dispatch(
              setStripeErrorAction(
                prevPaymentMethodId === ''
                  ? 'カード情報の登録中にエラーが発生しました。'
                  : 'カード情報の更新に失敗しました。'
              )
            )
            break
        }
      }
    }
  }
}

export default registerCard
